/**
 * Conversão recursiva snake_case <-> camelCase em payloads JSON.
 *
 * Convenção do backend Amplamais:
 *   - Frontend ENVIA em snake_case (este módulo converte ao serializar)
 *   - Backend RESPONDE em camelCase (mantemos como vem)
 */

const snakeToCamel = (s: string): string =>
  s.replace(/_([a-z0-9])/g, (_, c) => c.toUpperCase())

const camelToSnake = (s: string): string =>
  s.replace(/([A-Z])/g, '_$1').toLowerCase()

export function toSnakeCase<T = unknown>(input: T): T {
  if (Array.isArray(input)) {
    return input.map((v) => toSnakeCase(v)) as unknown as T
  }
  if (input !== null && typeof input === 'object' && !(input instanceof Date) && !(input instanceof File)) {
    const out: Record<string, unknown> = {}
    for (const [k, v] of Object.entries(input)) {
      out[camelToSnake(k)] = toSnakeCase(v as unknown)
    }
    return out as unknown as T
  }
  return input
}

export function toCamelCase<T = unknown>(input: T): T {
  if (Array.isArray(input)) {
    return input.map((v) => toCamelCase(v)) as unknown as T
  }
  if (input !== null && typeof input === 'object' && !(input instanceof Date) && !(input instanceof File)) {
    const out: Record<string, unknown> = {}
    for (const [k, v] of Object.entries(input)) {
      out[snakeToCamel(k)] = toCamelCase(v as unknown)
    }
    return out as unknown as T
  }
  return input
}
